<div class="audio-recording-container">
  <h1 class="audio-recording-title" transloco="audio.recording.dialogHeader"
 tabindex="0">Audio Recording</h1>
  <div *ngIf="!doneRecording"
     class="audio-record-horizontal-line">
    <div class="audio-record-circle"></div>
    <div class="hidden-audio-circle"></div>
    <div id="count-down" class="countdown-timer"></div>
    <aero-button
      *ngIf="!isRecording"
      [size]="buttonSize"
      styleClass="audio-button-start"
      labelCode="button_start"
      (onClick)="startRecording()">
    </aero-button>
    <aero-button
      *ngIf="isRecording"
      [size]="buttonSize"
      styleClass="audio-button-stop"
      labelCode="button_stop"
      (onClick)="stopRecording()">
    </aero-button>
  </div>
  <div class="audio-recording-footer">
    <!-- Cancel button -->
    <button
      *ngIf="!doneRecording"
      class="audio-recording-cancel"
      (click)="closeAudioDialogKeyPress($event)"
      (keypress)="closeAudioDialogKeyPress($event)">
      <p transloco="audio.recording.cancel"
>Cancel</p>
    </button>
  </div>
</div>
<!-- Create Audio Visual from the User's Microphone -->
<div id="audio-recording-microphone-waveform"></div>
<!-- Preview the recorded Audio -->
<audio-playback
  *ngIf="doneRecording"
  [audioSrc]="blobSrc"
  [exceededRecordingLimit]=exceededRecordingLimit
  [audioRecordingTimeDifference]="recordingTimeDifference"
  (deleteAudioRecordingEmitter)="handleDeleteAudioRecording($event)"
  (downloadAudioRecordingEmitter)="handleAudioRecordingDownload($event)"
  (saveAudioRecordingEmitter)="handleAudioRecordingSave($event)">
</audio-playback>
